import {Injectable} from "@angular/core";
import {LocationModel} from "./location.model";

@Injectable()
export class LocationService {

  // 定义一些常量
  bdsUtils = {
    x_PI: 3.14159265358979324 * 3000.0 / 180.0,
    PI: 3.1415926535897932384626,
    a: 6378245.0,
    ee: 0.00669342162296594323,
  };

  constructor() {
  }

  /**
   * 获取地址前需要将gcj02 、bd09 转换为wgs84
   * @param option
   */
  getLocation(option: { longitude: any, latitude: any, type: TYPE_ENUM, onOk: (value: any) => void }) {
    if (!option.longitude || !option.longitude) return;
    if (option.onOk) {
      let xy: Array<any>;
      switch (option.type) {
        case TYPE_ENUM.GCJ02:
          xy = this.gcj02towgs84(option.longitude, option.latitude);
          break;
        case TYPE_ENUM.BD09:
          xy = this.bd09towgs84(option.longitude, option.latitude);
          break;
        case TYPE_ENUM.WGS84:
          xy = [option.longitude, option.latitude];
          break;
      }

      this.queryAddressInfo(xy[0], xy[1]).then(data => {
        option.onOk(data);
      }).catch(() => {
        option.onOk(null);
      });

    }
  }


  /**
   * 获取地址信息
   * @param lon 坐标的x值
   * @param lat 坐标的y值
   */
  queryAddressInfo(lon: any, lat: any): LocationModel | any {
    return new Promise((resolve, reject) => {
      const param = {
        lon: lon,
        lat: lat,
        ver: 1 // 接口版本
      };
      const url = '//api.tianditu.gov.cn' + '/geocoder?postStr=' + JSON.stringify(param) + '&type=geocode&tk=40b42d3bf171b3e50dd21cd002efaa23';
      const xmlHttp = new XMLHttpRequest();
      xmlHttp.open('GET', url);
      xmlHttp.withCredentials = false;
      xmlHttp.send();
      xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
              const res = JSON.parse(xmlHttp.responseText);
              if (res.status == '0') {
                resolve(res.result);
              } else {
                reject(null);
                console.error('错误1' + res.msg);
              }
        }
      };
      xmlHttp.onerror = function (error) {
            console.error("错误2" + error);
            reject(null)
      };
    })
  }

  /**
   * 判断是否在国内，不在国内则不做偏移
   * @param lng
   * @param lat
   */
  outOfChina(lng, lat) {
    return (lng < 72.004 || lng > 137.8347) || ((lat < 0.8293 || lat > 55.8271) || false)
  }

  /**
   * 纬度转换
   * @param lng
   * @param lat
   */
  transformlng(lng, lat) {
    let ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
    ret += (20.0 * Math.sin(6.0 * lng * this.bdsUtils.PI) + 20.0 * Math.sin(2.0 * lng * this.bdsUtils.PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(lng * this.bdsUtils.PI) + 40.0 * Math.sin(lng / 3.0 * this.bdsUtils.PI)) * 2.0 / 3.0;
    ret += (150.0 * Math.sin(lng / 12.0 * this.bdsUtils.PI) + 300.0 * Math.sin(lng / 30.0 * this.bdsUtils.PI)) * 2.0 / 3.0;
    return ret
  }

  /**
   * 经度转换
   * @param lng
   * @param lat
   */
  transformlat(lng, lat) {
    let ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
    ret += (20.0 * Math.sin(6.0 * lng * this.bdsUtils.PI) + 20.0 * Math.sin(2.0 * lng * this.bdsUtils.PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(lat * this.bdsUtils.PI) + 40.0 * Math.sin(lat / 3.0 * this.bdsUtils.PI)) * 2.0 / 3.0;
    ret += (160.0 * Math.sin(lat / 12.0 * this.bdsUtils.PI) + 320 * Math.sin(lat * this.bdsUtils.PI / 30.0)) * 2.0 / 3.0;
    return ret
  }

  /**
   * 百度坐标系 (BD-09) 与 火星坐标系 (GCJ-02)的转换 / 即百度转谷歌、高德
   * @param bd_lon
   * @param bd_lat
   */
  bd09togcj02(bd_lon, bd_lat) {
    const x = bd_lon - 0.0065;
    const y = bd_lat - 0.006;
    const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * this.bdsUtils.x_PI);
    const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * this.bdsUtils.x_PI);
    const gg_lng = z * Math.cos(theta);
    const gg_lat = z * Math.sin(theta);
    return [gg_lng, gg_lat];
  }

  /**
   * 火星坐标系 (GCJ-02) 与百度坐标系 (BD-09) 的转换 / 即谷歌、高德 转 百度
   * @param lng
   * @param lat
   */
  gcj02tobd09(lng, lat) {
    const z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * this.bdsUtils.x_PI);
    const theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * this.bdsUtils.x_PI);
    const bd_lng = z * Math.cos(theta) + 0.0065;
    const bd_lat = z * Math.sin(theta) + 0.006;
    return [bd_lng, bd_lat];
  }

  /**
   * WGS84坐标系转火星坐标系GCj02 / 即WGS84 转谷歌、高德
   * @param lng
   * @param lat
   */
  wgs84togcj02(lng, lat) {
    if (this.outOfChina(lng, lat)) {
      return [lng, lat]
    } else {
      let dlat = this.transformlat(lng - 105.0, lat - 35.0);
      let dlng = this.transformlng(lng - 105.0, lat - 35.0);
      const radlat = lat / 180.0 * this.bdsUtils.PI;
      let magic = Math.sin(radlat);
      magic = 1 - this.bdsUtils.ee * magic * magic;
      const sqrtmagic = Math.sqrt(magic);
      dlat = (dlat * 180.0) / ((this.bdsUtils.a * (1 - this.bdsUtils.ee)) / (magic * sqrtmagic) * this.bdsUtils.PI);
      dlng = (dlng * 180.0) / (this.bdsUtils.a / sqrtmagic * Math.cos(radlat) * this.bdsUtils.PI);
      const mglat = lat + dlat;
      const mglng = lng + dlng;
      return [mglng, mglat];
    }
  }

  /**
   * GCJ02（火星坐标系） 转换为 WGS84 / 即谷歌高德转WGS84
   * @param lng
   * @param lat
   */
  gcj02towgs84(lng, lat) {
    if (this.outOfChina(lng, lat)) {
      return [lng, lat]
    } else {
      let dlat = this.transformlat(lng - 105.0, lat - 35.0);
      let dlng = this.transformlng(lng - 105.0, lat - 35.0);
      const radlat = lat / 180.0 * this.bdsUtils.PI;
      let magic = Math.sin(radlat);
      magic = 1 - this.bdsUtils.ee * magic * magic;
      const sqrtmagic = Math.sqrt(magic);
      dlat = (dlat * 180.0) / ((this.bdsUtils.a * (1 - this.bdsUtils.ee)) / (magic * sqrtmagic) * this.bdsUtils.PI);
      dlng = (dlng * 180.0) / (this.bdsUtils.a / sqrtmagic * Math.cos(radlat) * this.bdsUtils.PI);
      const mglat = lat + dlat;
      const mglng = lng + dlng;
      return [lng * 2 - mglng, lat * 2 - mglat];
    }
  }

  /**
   * 百度坐标系转wgs84坐标系
   * @param lng
   * @param lat
   */
  bd09towgs84(lng, lat) {
    // 百度坐标系先转为火星坐标系
    const gcj02 = this.bd09togcj02(lng, lat);
    // 火星坐标系转wgs84坐标系
    return this.gcj02towgs84(gcj02[0], gcj02[1]);
  }

  /**
   * wgs84坐标系转百度坐标系
   * @param lng
   * @param lat
   */
  wgs84tobd09(lng, lat) {
    // wgs84先转为火星坐标系
    const gcj02 = this.wgs84togcj02(lng, lat);
    // 火星坐标系转百度坐标系
    return this.gcj02tobd09(gcj02[0], gcj02[1]);
  }
}


// 坐标系枚举
export enum TYPE_ENUM {
  GCJ02 = 'gcj02', // 火星坐标系
  BD09 = 'bd09', // 百度坐标系
  WGS84 = 'wgs84'  // WGS84坐标系
}
